import $ from "jquery";

const $accordions = $(".accordion__item");

$.each($accordions, function () {
  const $t = $(this);

  if ($t.data("collapse")) {
    $t.removeClass("is--active").find(".accordion__contents").hide();
  }
});

$("body").on("click", ".accordion__item button", function () {
  const $item = $(this).parents(".accordion__item");
  const $contents = $item.find(".accordion__contents");

  $contents.stop().slideToggle(180, function () {
    $item.toggleClass("is--active");
  });
});

let hash = window.location.hash;
if (hash) {
  const id = hash.replace("#", "");

  if ($(".js-target-" + id).length) {
    $(".js-target-" + id)
      .first()
      .find(".accordion__item")
      .addClass("is--active")
      .find(".accordion__contents")
      .slideToggle(0);

    $("body,html").animate(
      {
        scrollTop:
          $(".js-target-" + id)
            .first()
            .offset().top - 100,
      },
      500,
    );
  }
}
